import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { OverallRating } from '../components';

const mapStateToProps = ({ product }: ReduxApplicationState) => ({
  productRating: product.productRating,
  numberOfReviews: product.numberOfReviews,
});

export const OverallRatingContainer = connect(mapStateToProps)(OverallRating);
